// @ts-nocheck
/* eslint-disable */
import { addListener } from "~/lib/signals";

/**
 * Dialogova okna - spravce. Vytvari, obsluha ESC...
 */
Mapy.Popup = class {
	constructor() {
		this._popupList = [];
		this._timeOutID = null;
	
		addListener(this, "width-change", "_resizeAllPopups");
	}
	
	/**
	 * Vytvoreni alertu - okno pouze s textem.
	 * 
	 * @param  {String} str text do okna
	 * @param  {String} [id] vlastni ID, default random
	 * @return {Mapy.Popup.Window}
	 */
	createAlert(str, id) {
		var popup = new Mapy.Popup.Window({
			className: "system-alert",
			position: Mapy.Popup.Window.POSITIONS.CENTER_CENTER,
			id: id
		});
	
		var info = document.createElement("p");
		info.innerHTML = str;
	
		popup.getContentEl().appendChild(info);
	
		popup.setPosition();
	
		return popup;
	}
	
	// zavri popup okno se zadanym ID
	closePopup(popupID) {
		if (!popupID) return;
	
		for (var i = 0; i < this._popupList.length; i++) {
			var item = this._popupList[i];
	
			if (item.getId() == popupID) {
				item.close();
				break;
			}
		}
	}
	
	/**
	 * Registrace noveho popup okna.
	 * 
	 * @param  {Mapy.Popup.Window} win Instance
	 */
	registerPopup(win) {
		this._popupList.push(win);
	
		if (this._popupList.length == 1) {
			this._bindsFn();
		}
	}
	
	/**
	 * Odregistrace noveho popup okna.
	 * 
	 * @param  {Mapy.Popup.Window} win Instance
	 */
	unregisterPopup(win) {
		for (var i = 0; i < this._popupList.length; i++) {
			if (win.getId() == this._popupList[i].getId()) {
				this._popupList.splice(i, 1);
	
				if (!this._popupList.length) {
					this._unbindsFn();
				}
	
				break;
			}
		}
	}
	
	handleEvent(e) {
		var type = e && e.type ? e.type : "";
	
		switch (type) {
			case "keydown":
				var keyCode = e.which || e.keyCode;
	
				if (keyCode == 27) {
					// esc
	
					e.stopPropagation();
	
					var lw = null;
	
					for (var i = 0; i < this._popupList.length; i++) {
						if (this._popupList[i].hasFocus()) {
							lw = this._popupList[i];
							break;
						}
	
						// posledni okno
						if (i == this._popupList.length - 1) {
							lw = this._popupList[i];
						}
					}
	
					if (lw) {
						lw.close();
					}
				}
				break;
	
			case "resize":
				if (this._timeOutID) {
					clearTimeout(this._timeOutID);
					this._timeOutID = null;
				}
	
				this._timeOutID = setTimeout(this._onResizeEnd.bind(this), 100);
				break;
		}
	}
	
	_bindsFn() {
		document.addEventListener("keydown", this, false);
		window.addEventListener("resize", this, false);
	}
	
	_unbindsFn() {
		document.removeEventListener("keydown", this, false);
		window.removeEventListener("resize", this, false);
	}
	
	_onResizeEnd() {
		this._resizeAllPopups();
	}
	
	_resizeAllPopups() {
		this._popupList.forEach(function(w) {
			w.setPosition();
		});
	}
};
